import {TTAppState} from "./tt-app-state";
import {fetchPublic} from "./tt-req";
import {TTPageLoader} from "./tt-page-loader";
import {TTLiveUpdate} from "./tt-live-update";
import * as Sentry from "@sentry/browser";

export class TTAppStatemachine {

    // "state"
    // - page data
    // - user
    // ======>
    // "rendered state" <- app.state

    constructor(app) {
        this.app = app;
        this.state = {
            pageData: null,
            user: null
        }

        this.liveUpdate = new TTLiveUpdate(
            () => {
                this._loadPage(window.location.pathname)
                    .then(_ => this.updateUI())
                    .catch(e => this._handleError(e))
            },
            () => this.state.pageData?.type,
            app
        )
    }

    // both methods user() and to() need to use the same "calculation" to derive rendered state

    // updates user data -> as a result rendered state might be updated
    user(user) {

        if (user) {
            console.log("User: ", user.displayName);
            Sentry.configureScope((scope) => {
                scope.setUser({"email": user.email});
            });
        } else {
            console.log("No user...");
        }

        this.state.user = user
        this.app.user = user
        // update
        this.updateUI()
    }

    updateUI() {
        if (!this.state.pageData) {
            return Promise.resolve()
        }

        if (this.state.pageData && this.state.pageData.userRequired && !this.state.user) {
            return new TTPageLoader()
                .load("community-login")
                .then(_ => this.app.state = TTAppState.loginRequired())
                .catch(e => this.app.state = TTAppState.error())
        }

        return new TTPageLoader()
            .load(this.state.pageData.type)
            .then(_ => this.app.state = TTAppState.page(this.state.pageData))
            .catch(_ => this.app.state = TTAppState.error())
    }

    // updates page data -> as a result rendered state might be updated
    to(url) {
        this.app.state = TTAppState.loading(url)
        this._loadPage(url)
            .then(_ => this.updateUI())
            .catch(e => this._handleError(e))
    }

    _handleError(e) {
        switch (e) {
            case "404":
                this.app.state = TTAppState.notFound()
                return;
            case "5xx":
                this.app.state = TTAppState.serverError()
                return;
            default:
                if (!navigator.onLine) {
                    this.app.state = TTAppState.networkError()
                    return;
                }

                Sentry.captureException(e);
                this.app.state = TTAppState.error()
        }
    }

    _loadPage(url) {
        let path = ""
        if (url === "/") {
            path = "/frontpage"
        } else {
            path = url
        }

        return fetchPublic(`${API.base}${path}`)
            .then(resp => {
                if (resp.status === 404) {
                    return Promise.reject("404")
                }

                if (resp.status >= 500) {
                    return Promise.reject("5xx")
                }

                return resp.json()
            })
            .then(pageData => this.state.pageData = pageData)
            .then(pageData => {
                this.liveUpdate.update(pageData.notificationGroup)
                return pageData
            })
    }

}